import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import TextArea from '../../../common/Form/TextArea';
import { updateRemark } from '../../../actions/service_request';
import { useState } from 'react';
import RenderMilestones from '../components/RenderMileStones';
import { TicketMilestoneEvents } from '../TicketController';
import Milestone from '../../../components/Inputs/MileStone';

const formName = 'updateSignOffNotesForm';

export default function UpdateSignOffNotes({ ticketId, milestones = [], agents }) {
    const [selectedMilestones, setSelectedMilestones] = useState();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const defaultValues = { remark: '' };
    const dispatch = useDispatch();
    const serviceRequestList = useSelector((state) => state.serviceRequest.serviceRequestList);

    const methods = useForm({ defaultValues, mode: 'all' });


    const signoffRemark = useMemo(() => {
        const ticket = serviceRequestList.data.find(({ id }) => id === ticketId);
        const findRemark = ticket.remarks.find(({ action, milestone_id }) => action === TicketMilestoneEvents.MILESTONE_SIGN_OFF_REQUESTED && milestone_id === selectedMilestones);
        return findRemark;
    }, [serviceRequestList, ticketId, selectedMilestones]);

    useEffect(() => {
        if (signoffRemark?.remark) {
            methods.setValue('remark', signoffRemark.remark);
        }
    }, [signoffRemark?.remark, methods]);

    const submit = (formValues) => {
        const payload = { remark: formValues.remark };
        const ledgerId = signoffRemark.id;
        dispatch(updateRemark({ ticketId, ledgerId, payload, formName }));
    };

    return (
        <div className="relative overflow-hidden">
            <div className='px-4 py-2'>
                <RenderMilestones milestones={milestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={agents} />
            </div>
            <Form
                methods={methods}
                onSubmit={submit}
                formName={formName}
                buttonPostion={'justify-end'}
                submitButtonText={'Submit'}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
            >
                <div className='px-2'>
                    <TextArea name='remark' className='w-full' label='SignOff Notes' height='6rem' required />
                </div>
            </Form>
        </div>
    );
}
